/*
 * @Author: Lina
 * @Date: 2020-06-29 11:43:31
 * @LastEditors: Lina
 * @LastEditTime: 2020-09-11 16:32:22
 */
import h5RouterConfig from './h5Router';
import qaRouterConfig from './qaRouter';
import appRouterConfig from './appRouter';
import qqmpRouterConfig from './qqmpRouter';
import wxmpRouterConfig from './wxmpRouter';
import qaFun from './qaFun';
import Utils from './utils';
import { businessTypeListAll } from './constant';

const login = async cb => {
  const login = await window.crgt.router.openLogin();
  if (login.code === 0) {
    cb && cb();
  }
};

const loginThenRedirect = async (config, params) => {
  if (config.needLogin) {
    const token = await window.crgt.getToken();
    if (!token) {
      return await login(() => goToH5Page(config, params));
    }
  }
  return goToH5Page(config, params);
}

const goToH5Page = async (config, params) => {
  const url = config.path;
  const token = await window.crgt.getToken();
  const dataParams = Utils.jumptoSearchUrl({ ...config.params, ...params, token: config.withToken ? token : undefined });
  const urlPath = dataParams ? `${url}${url.split('#')[1]?.includes('?') ? '&' : '?'}${dataParams}` : url;
  console.log(
    'goToH5Page ===>', 'dataParams', dataParams, 'url', urlPath
  );
  return window.location.href = urlPath;
};
const routerTypeAll = {
  h5RouterFun: async ({ config, params }) => {
    return goToH5Page(config, params)

  },

  qaRouterFun: ({ config, params }) => {
    const url = config.path;
    if (!config.isNativePage) {
      return loginThenRedirect(config, params)

    } else {

      const data = Object.assign({}, config.params, params)
      console.log(
        'goToQANativePage ===>', 'url', url, data
      );
      qaFun.postMessage(qaFun.Action[config.type], {
        path: url,
        data: data || {}
      });
    }
  },

  appRouterFun: ({ config, params }) => {
    if (!config.isNativePage) {
      return loginThenRedirect(config, params)
    } else {
      console.log('url===',
        config.type,
        JSON.stringify({
          protocol: config.protocol,
          path: config.path,
          params: {
            ...config.params,
            ...params,
          },
        }),
      );
      window.crgt.router[config.type]({
        protocol: config.protocol,
        path: config.path,
        params: {
          ...config.params,
          ...params,
        },
      });
    }
  },

  qqmpRouterFun: ({ config, params }) => {
    return goToH5Page(config, params)
  },

  wxmpRouterFun: ({ config, params }) => {
    if (!config.isNativePage) {
      const url = config.params.url;
      const dataParams = Utils.jumptoSearchUrl(params);
      const path = encodeURIComponent(dataParams ? `${url}${url.split('#')[1]?.includes('?') ? '&' : '?'}${dataParams}` : url)
      const urlPath = `${config.path}?url=${path}`;


      console.log(
        'dataParams', dataParams,
      );
      console.log('url', urlPath,)

      return window.wx.miniProgram.navigateTo({
        url: urlPath,
      });
    } else {
      console.log(
        'url', config.path
      );
      window.wx.miniProgram.navigateTo({
        url: config.path,
      });
    }
  },
};


(function () {
  window.crgt.router.businessTypeListAll = businessTypeListAll;
  window.crgt.router.go = ({ business, params }) => {
    if (!window.crgt) return false;
    const routerMap = new Map([
      [window.crgt.isCRGT, { config: appRouterConfig, data: 'appRouterFun' }],
      [window.crgt.isQA, { config: qaRouterConfig, data: 'qaRouterFun' }],
      [window.crgt.isWXMp, { config: wxmpRouterConfig, data: 'wxmpRouterFun' }],
      [window.crgt.isQQMp, { config: qqmpRouterConfig, data: 'qqmpRouterFun' }],
      ['default', { config: h5RouterConfig, data: 'h5RouterFun' }],
    ]);

    const getRouterConfig = routerMap.get(true) || routerMap.get('default');
    const config = getRouterConfig.config[business];
    if (!config) { console.log('暂不支持此业务'); return false; }
    routerTypeAll[getRouterConfig.data]({ config, params });
    return true;
  };
})();
